// extracted by mini-css-extract-plugin
export default {"formWrap":"NewUser_formWrap__wzIFG"};